import 'src/App.css';
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
// import createTheme from "@mui/material/styles/createTheme";
import React, {useState, 
    // lazy
} from "react";
import Splash from "src/components/splash";
import 'src/assets/css/index.css'

import Home from "./components/home";
import Service from "./components/services";
import OurWork from "./components/our-work";
import ServiceDetails from "./components/service-details";
import Blogs from "./components/blogs";
import BlogDetails from "./components/blog-details";
import OurTeamDetails from "./components/our-team-details";
import AboutUsDetails from "./components/about-us-details";
import TermsCondition from "./components/terms-condition";
import PrivacyPolicy from "./components/privacy-policy";
import RefundPolicy from "./components/refund-policy";
import Certifications from "./components/certifications";
import ContactUsDetails from "./components/contact-us-details";
import UiUxDesign from "./components/services-detail/ui-ux-detail";
import SaasDetail from "./components/services-detail/saas-detail";
import MobAppDetail from "./components/services-detail/mobile-app-services-detail";
import WebAppDetail from "./components/services-detail/web-app-services-detail";
import GraphicDetail from "./components/services-detail/graphic-design-detail";
import VedioDetail from "./components/services-detail/vedio-edit-detail";
import BrandkitDetails from "./components/services-detail/brand-kit-detail";
import FeDevDetail from "./components/services-detail/frontend-dev-detail";
import BeDevDetail from "./components/services-detail/backend-dev-detail";
import FsDevDetail from "./components/services-detail/full-stack-detail";
import QaDetail from "./components/services-detail/qa-detail ";
import DevopsDetail from "./components/services-detail/devops-detail";
import AIMLDetail from "./components/services-detail/ai-ml-detail";
import CustSoftDetail from "./components/services-detail/custom-soft-detail";
import PromoVideo from "./components/promo-video";

// const Home = lazy(() => import("./components/home"));
// const Service = lazy(() => import("./components/services"));
// const OurWork = lazy(() => import("./components/our-work"));

// const theme = createTheme({
//     components: {
//         MuiButton: {
//             styleOverrides: {
//                 root: {
//                     boxShadow: 'none',
//                     '&:hover': {
//                         boxShadow: 'none', // Removes hover shadow too
//                     },
//                 },
//             },
//         },
//     },
//     breakpoints: {
//         values: {
//             xs: 0,
//             sm: 710,
//             md: 950,
//             lg: 1300,
//             xl: 1350,
//         },
//     },
// });

function App() {
    const [isAnimating,setIsAnimating]=useState(true);


    return (
        <>
            {isAnimating &&
                <Splash setIsAnimating={setIsAnimating}/>
            }
                <Router>
                    <Routes>
                        <Route path="/" element={<Home/>}/>
                        <Route path="services" element={<Service/>}/>
                        <Route path="our-work" element={<OurWork/>}/>
                        <Route path="service-details" element={<ServiceDetails/>}/>
                        <Route path="blogs" element={<Blogs/>}/>
                        {/* <Route path="blog-details" element={<BlogDetails/>}/> */}
                        <Route path="/:blogId" element={<BlogDetails/>}/>
                        <Route path="our-team" element={<OurTeamDetails/>}/>
                        <Route path="about-us" element={<AboutUsDetails/>}/>
                        <Route path="terms-condition" element={<TermsCondition/>}/>
                        <Route path="privacy-policy" element={<PrivacyPolicy/>}/>
                        <Route path="refund-policy" element={<RefundPolicy/>}/>
                        <Route path="certifications" element={<Certifications/>}/>
                        <Route path="contact-us" element={<ContactUsDetails/>} key="contact"/>
                        <Route path="ui-ux-design" element={<UiUxDesign/>}/>
                        <Route path="saas-detail" element={<SaasDetail/>}/>
                        <Route path="mobile-app-development" element={<MobAppDetail/>}/>
                        <Route path="web-app-development" element={<WebAppDetail/>}/>
                        <Route path="graphic-design-detail" element={<GraphicDetail/>}/>
                        <Route path="vedio-edit-detail" element={<VedioDetail/>}/>
                        <Route path="brand-kit-detail" element={<BrandkitDetails/>}/>
                        <Route path="frontend-dev-detail" element={<FeDevDetail/>}/>
                        <Route path="backend-dev-detail" element={<BeDevDetail/>}/>
                        <Route path="full-stack-detail" element={<FsDevDetail/>}/>
                        <Route path="quality-assurance-detail" element={<QaDetail/>}/>
                        <Route path="devops-cloud" element={<DevopsDetail/>}/>
                        <Route path="ai-mechine-learning" element={<AIMLDetail/>}/>
                        <Route path="custom-software-development" element={<CustSoftDetail/>}/>
                        <Route path="on-demand-developers" element={<Service/>}/>
                        <Route path="full-project-development" element={<Service/>}/>
                        <Route path="project-by-equity" element={<Service/>}/>
                        <Route path="promo-video" element={<PromoVideo/>}/>
                    </Routes>
                </Router>

        </>
    );
}

export default App;
